import { useState } from "react";
import { getAniosRecurrenciaData, getDescripcionRecurrenciaData, getRecurrenciaByYearData } from "../api/recurrencia";
import { ChartColorsDto, RecurrenciaAniosDto, RecurrenciaDescripcionDto } from "../models/Recurrencia.model";

export const useRecurrencia = () => {
    const [years, setYears] = useState<RecurrenciaAniosDto[]>([]);
    const [selectYear, setSelectYear] = useState("");
    const [recurrenciaData, setRecurrenciaData] = useState<[string, number][]>([]);
    const [descripcion, setDescripcion] = useState<RecurrenciaDescripcionDto[]>([])
    const [chartColors, setChartColors] = useState<ChartColorsDto[]>([]);

    const getAniosRecurrencia = async () => {
        try {
            const data = await getAniosRecurrenciaData();

            setSelectYear(data[0].value);
            getRecurrenciaByYear(data[0].value)
            setYears(data);
        } catch (err) {
            console.warn(err);
        }
    };

    const getRecurrenciaByYear = async (year: string) => {
        try {
            const data = await getRecurrenciaByYearData(year);
            const solicitudes: [string, number][] = [];
            const colores: ChartColorsDto[] = [];
    
            data?.data.forEach((item: any) => {
                const key: string = item[0];
                const value: string = item[1];
    
                if (key.startsWith("Solicitudes")) {
                    solicitudes.push([key, parseInt(value, 10)]);
                } else if (key.endsWith("_hexadecimal")) {
                    colores.push({ color: value ? value : "#2A275C" });
                }
            });

            setChartColors(colores)
            setRecurrenciaData(solicitudes)
        } catch (err) {
            console.warn(err);
        }
    };

    const getDescripcionRecurrencia = async () => {
        try {
            const data = await getDescripcionRecurrenciaData();
           setDescripcion(data);
        } catch (err) {
            console.warn(err);
        }
    };


    const handleChangeSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setSelectYear(e.target.value);
        getRecurrenciaByYear(e.target.value)
    };


    return {
        getAniosRecurrencia,
        years,
        selectYear,
        getRecurrenciaByYear,
        recurrenciaData,
        handleChangeSelect,
        getDescripcionRecurrencia,
        descripcion,
        chartColors,
    }
}
